module.exports = __webpack_public_path__ + "img/1.47cb1776.jpg";